import axios from 'axios'
import {
    MessageBox,
    Message
} from 'element-ui'
import store from '@/store'
import {
    getToken,
    getUserid
} from '@/utils/auth'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 120000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Admin-Token'] = getToken()

        }
        if (store.getters.userid) {
            config.headers['Admin-UserId'] = getUserid()
        }

        if (config.url.indexOf("ScreeingVisionResult") > -1) {
            config.timeout = 600000;
        }

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */
    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {

        const res = response.data
        if (response.data instanceof Blob) {
            return res
        } else {
            if (res.code !== 200) {
                Message({
                    message: res.msg || res.message || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })
    
                // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
                if (res.code === 401 || res.code === 50008 || res.code === 50012 || res.code === 50014) {
                    // to re-login
                    MessageBox.confirm('登录过期或失效', '请确认', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        store.dispatch('user/resetToken').then(() => {
                            location.reload()
                        })
                    })
                }
                return res
                // return Promise.reject(new Error(res.message || 'Error'))
            } else {
                return res
            }
        }

        // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 200) {
        //     Message({
        //         message: res.msg || res.message || 'Error',
        //         type: 'error',
        //         duration: 5 * 1000
        //     })

        //     // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        //     if (res.code === 401 || res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //         // to re-login
        //         MessageBox.confirm('登录过期或失效', '请确认', {
        //             confirmButtonText: '重新登录',
        //             cancelButtonText: '取消',
        //             type: 'warning'
        //         }).then(() => {
        //             store.dispatch('user/resetToken').then(() => {
        //                 location.reload()
        //             })
        //         })
        //     }
        //     // return Promise.reject(new Error(res.message || 'Error'))
        // } else {
        //     return res
        // }
    },
    error => {
        console.log('err： ' + error) // for debug
            // 处理错误信息
        if (error.response) {
            const res = error.response.data
            if (res.code === 401) {
                MessageBox.confirm(res.message, '提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        location.reload()
                    })
                }).catch(() => {})
            } else {
                Message({
                    showClose: true,
                    message: res.message || error.message,
                    type: 'error',
                    duration: 5000
                })
            }
        } else {
            Message({
                message: '网络请求超时，请稍后再试', // error.message || 
                type: 'error',
                duration: 5 * 1000
            })
        }

        return Promise.reject(error)
    }
)

export default service